// src/hooks/usePushNotifications.js
// Call this hook once in ChatPage.jsx

import { useEffect } from "react";
import axios from "axios";
import localforage from "localforage";

const API_URL     = process.env.REACT_APP_API_URL;
const VAPID_KEY   = process.env.REACT_APP_VAPID_PUBLIC_KEY;

// Convert base64 VAPID key to Uint8Array (required by browser API)
const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw     = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const usePushNotifications = (currentUserEmail) => {
  useEffect(() => {
    if (!currentUserEmail || !("serviceWorker" in navigator) || !("PushManager" in window)) return;

    const setup = async () => {
      try {
        // 1 — Register service worker
        const registration = await navigator.serviceWorker.register("/push-sw.js");

        // 2 — Ask permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        // 3 — Subscribe to push
        let subscription = await registration.pushManager.getSubscription();
        if (!subscription) {
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly:      true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_KEY),
          });
        }

        // 4 — Send subscription to backend
        const tok = await localforage.getItem("token");
        if (!tok) return;

        await axios.post(
          `${API_URL}/chat/push-subscription`,
          subscription.toJSON(),
          { headers: { Authorization: `Bearer ${tok}` } }
        );
      } catch (err) {
        console.warn("[Push] Setup failed:", err.message);
      }
    };

    setup();
  }, [currentUserEmail]);
};

export default usePushNotifications;